
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard, AppSwitch } from '@/components';
import { useTotem } from '@/modules/totem/model/edit';
import { ROUTE_NAME_TOTEM } from '@/modules/totem/router';

export default defineComponent({
    name: ROUTE_NAME_TOTEM,
    components: { AppFormRow, AppInput, AppButton, AppCard, AppSwitch },
    setup() {
        const { model, v$, fetch, update } = useTotem();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, update };
    }
});
